// Detached Vuetify overlays can contain HR data outside the page root.
export const replayPrivacy = {
    maskAllText: true,
    maskAllInputs: true,
    blockAllMedia: true,
    block: [".hr-page", ".hr-embedded", ".v-dialog__content", ".v-menu__content"],
};
